import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility for merging Tailwind CSS classes with proper precedence.
 *
 * #8814: kept LOCAL here on purpose — do NOT re-export `cn` from
 * `@smallbiz/ui-primitives`. `@smallbiz/ui-primitives` already depends on
 * `@smallbiz/brand-kit` (ui-primitives/package.json + src/select.tsx re-exports
 * Select from brand-kit), so importing `cn` FROM ui-primitives here would close
 * a 2-package `brand-kit ⇄ ui-primitives` cycle. The dedup still consolidates
 * the other `cn` copies onto ui-primitives; brand-kit keeps its own tiny local
 * copy to stay acyclic.
 *
 * @param inputs - Class names or conditional class objects
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
